import { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { notifySessionExpired } from '../authSession';
import { apiRequest } from '../authConfig';
import { getApiAccessToken } from '../services/tokenService';

export const useApiAuth = () => {
  const { instance, accounts } = useMsal();

  const getAccessToken = useCallback(async (): Promise<string | null> => {
    const token = await getApiAccessToken();
    if (token) {
      return token;
    }

    if (accounts.length === 0) {
      return null;
    }

    try {
      const response = await instance.acquireTokenPopup({
        ...apiRequest,
        account: accounts[0],
      });
      return response.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        console.warn('Sign-in required to continue');
        notifySessionExpired();
      } else {
        console.error('Interactive token acquisition failed:', error);
      }
      return null;
    }
  }, [instance, accounts]);

  return { getAccessToken };
};
